//@ts-nocheck
import { useState, useContext, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LoaderContext } from "../../../Helpers/Context/Context";
import Modal from "react-modal";
import fileDownload from "js-file-download";
import { APICall } from "../../../Helpers/Network/APICalls";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import axios from "axios";
import InputForm from "../../../Components/InputForm/InputForm";
import moment from "moment";
import "./LoanInterest.css";
import {
  getLoanInterestDashboardData,
  getLoanInterestExportToExcel,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { fetchAuthToken } from "../../../Helpers/Network/OAuthHandler";

Modal.setAppElement("#root"); // Use the selector for your root element

const LoanInterest = () => {
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [searchText, setSearchText] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [dashboardData, setDashboardData] = useState([]);

  useEffect(() => {
    getDashboardData("");
  }, [start, sortColumn, sortDirection, searchText, count]);

  const getDashboardData = async (btn: any) => {
    showLoader();
    let obj = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
    };

    const resp = await APICall(getLoanInterestDashboardData, obj);

    if (resp?.Data?.Data?.length > 0) {
      setDashboardData(resp?.Data?.Data);
    } else {
      setDashboardData([]);
    }

    setCount(resp?.Data?.Data[0]?.TotalCount || resp?.Data?.Data?.length || 0);
    hideLoader();
  };

  const exportToExcelFunction = async () => {
    const params = {
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: getLoanInterestExportToExcel,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
       
        fileDownload(
          response.data,
          `RateOfInterest_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
       
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const Options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };
  const GridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "LoanTypeName",
      label: "Loan Type",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "ROI",
      label: "Interest Rate",
      options: {
        display: true,
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return value + "%";
        },
      },
    },
    {
      name: "IsActive",
      label: "Active Status",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let id = tableMeta.rowData[0];
          return (
            <Tooltip title="edit">
              <p className="ml-3">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("edit", {
                      state: { id },
                    });
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </p>
            </Tooltip>
          );
        },
      },
    },
  ];

  return (
    <>
      <div className="form-main">
        <div className="page-title w-100">
          <div className="col-lg-12 p-0">
            <div className="row justify-content-end"> 
              <div className="col-xl-3 col-lg-4 col-md-6 SearchBoxLoanInterest">
                <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                  <div className="col-lg-12 mt-1 p-0 searchInput">
                    <InputForm
                      value={searchText}
                      placeholder={"Search"}
                      isDisabled={false}
                      textArea={false}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                    />
                    <i className="fa fa-search ml-2" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div className="col-xl-1 col-lg-1 col-md-1 ml-2 loa_m">
                <div
                  className="float-right col-sm-offset-2"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  {/* <Tooltip title="import to excel">
                    <button className="btn btn-submit" onClick={openModal}>
                      <i className="fa fa-upload"></i>
                    </button>
                  </Tooltip> */}

                  <Tooltip
                    title="export to excel"
                    style={{ marginLeft: "5px", cursor: "pointer" }}
                  >
                    <button
                      className="btn btn-submit"
                      onClick={() => {
                        if (dashboardData.length === 0) {
                          notify(1, "No data available");
                        } else {
                          exportToExcelFunction();
                        }
                      }}
                    >
                      <i className="fa fa-download"></i>
                    </button>
                  </Tooltip>

                  {/* <ButtonComponent
                    className="btn btn-submit"
                    style={{
                      marginLeft: 5,
                      cursor: "pointer",
                    }}
                    icon={""}
                    value={"Create"}
                    onClick={() => {
                      navigate("edit", {
                        state: {
                          id: 0,
                        },
                      });
                    }}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0">
        <div className="col-lg-12 p-0">
          <div className="row">
            <div className="col-lg-4 col-md-4"></div>
            <div className="col-lg-4 col-md-2"></div>
            <div className="col-lg-4 col-md-6">
              <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                <div className="col-lg-12 mt-1 p-0 searchInput">
                  <InputForm
                    value={searchText}
                    placeholder={"Search"}
                    isDisabled={false}
                    textArea={false}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                  <i className="fa fa-search ml-2" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div>
        <div className="clearfix"></div>
        <DynamicGrid
          options={Options}
          data={dashboardData}
          columns={GridColumns}
        />
      </div>
    </>
  );
};

export default LoanInterest;

{
  /* <ul
      className="float-right filter-icon "
    style={{ position: "relative" }}
  >
    <li
      onClick={() =>
        setDashboardFilterOn((current) => !current)
      }
      className="filter-btn"
    >
      <a className="filter-btn">
        <i className="fa fa-filter"></i>
      </a>
    </li>
  </ul> */
}

{
  /* <Collapse in={dashboardFilterOn}>
  <div className="filter-content pt-2 px-4">
    <div className="row">
      <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
        <div className="form-group">
          <label className="col-form-label">Loan Type</label>
          <SelectForm
            options={loanTypeOptions}
            placeholder="Select Loan Type"
            isDisabled={false}
            value={loanType}
            onChange={(event: any) => selectOnChange(event, "LoanType")}
            isMulti={true}
            noIndicator={false}
            noSeparator={false}
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div
        className="col-lg-12 col-md-12"
        style={{ marginBottom: "25px" }}
      >
        <div className="float-right">
          <button
            className="btn btn-cancel"
            style={{ marginLeft: 5 }}
            onClick={(e) => onClickFunction(e, "Reset")}
          >
            Reset
          </button>
          <button
            className="btn btn-info"
            style={{ marginLeft: 5 }}
            onClick={(e) => onClickFunction(e, "Apply")}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</Collapse> */
}

{
  /* <div className="ModalSize">
  <Modal
    ariaHideApp={false}
    isOpen={modalIsOpen}
    onRequestClose={closeModal}
    contentLabel="File Upload Modal"
    style={{
      content: {
        width: "30%", // Adjust this value as needed
        height: "16em", // Adjust this value as needed
        margin: "auto", // Center the modal horizontally
      },
    }}
  >
    <div className="col-lg-12 p-0">
      <div className="row">
        <div
          className="col-lg-12 col-md-12"
          style={{ marginBottom: "15px" }}
        >
          <div className="form-group"></div>
          <label>Import Excel</label>
          <sup style={{ fontSize: "13px" }}>*</sup>
          <input
autoComplete={AutoCompleteValue}
            onChange={bulkUploadRequestExcelFileChange}
            accept=".xlsx"
            className="form-control"
            type="file"
          />
          <p style={{ color: "red" }}>
            {formErrors["bulkUpload_isEmpty"]}
          </p>
        </div>
        <div className="col-lg-12 col-md-12">
          <button className="btn btn-submit" onClick={handleUpload}>
            Upload
          </button>
          <button
            className="btn btn-cancel"
            onClick={closeModal}
            style={{ marginLeft: "10px" }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </Modal>
</div> */
}
